import { createPostFetch } from '../../lib/createFetch';
import { SendEmailReq, SendEmailRes } from '../../pages/api/mail/sendEmail';

export const sendEmail = createPostFetch<SendEmailReq, SendEmailRes>(
    '/api/mail/sendEmail'
);
